<template>
    <b-tabs>
        <b-tab v-for="program in snippets" :key="program.key" :title="program.key" @click="setActive(program.key);
        load_code(program.sample_url);" :class="[{ active: isActive(program.key) }]">
            <div :class="[{ 'show': activeItem }, 'tab-pane', 'fade', 'p-0']">
                <b-button @click="copy" class="copyBtn">{{ $t('global.copy') }}</b-button>
                <pre v-highlightjs="code"><code :class="activeItem"></code></pre>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
import VueHighlightJS from 'vue-highlightjs';
import 'highlight.js/styles/monokai.css';

import Vue from 'vue';

Vue.use(VueHighlightJS);

export default {
  mounted() {
    this.load_code('Python.txt');
  },
  data() {
    return {
      snippets: [{
        key: /* transk 'language_snippet.btn_show' */ 'Python upload',
        highlight: 'python',
        sample_url: 'Python.txt',
      }, {
        key: /* transk 'language_snippet.btn_show' */ 'Python sample list',
        highlight: 'python',
        sample_url: 'Python_sample_list.txt',
      },
      {
        key: /* transk 'language_snippet.btn_show' */ 'Python sample info',
        highlight: 'python',
        sample_url: 'Python_get_sample_info.txt',
      }, {
        key: /* transk 'language_snippet.btn_show' */ 'Cpp upload',
        highlight: 'cpp',
        sample_url: 'Cpp.txt',
      }, {
        key: /* transk 'language_snippet.btn_show' */ 'Cpp sample list',
        highlight: 'cpp',
        sample_url: 'Cpp_sample_list.txt',
      }],
      seen: false,
      code: '',
      activeItem: 'Python upload',
    };
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.code);
    },
    load_code(programCode) {
      const url = `../code_snippets/${programCode}`;
      fetch(url).then((response) => response.text()).then((data) => {
        this.code = data;
      });
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
  }
};
</script>
<style scoped lang="scss">
.copyBtn{
  margin: 0 0 1em 0;
}
</style>
